import React, { useState, useEffect } from 'react';
import './index.css';  // Ensure you import the CSS file
import colorButton from './imgs/button-color-palette.png'
import muddyriaArt from './imgs/muddyria-art.png'

function App() {
  const [showProjects, setShowProjects] = useState(false);

  useEffect(() => {
    // Set the document title when the component mounts
    document.title = 'Muddyria Productions | Madhu Ratnakar';
  }, []); // The empty array means this effect runs only once (on mount)

  const handleShowProjects = () => {
    setShowProjects(!showProjects);
  };

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center text-slate-800 shadow=lg p-4"
      style={{ backgroundImage: `url(${muddyriaArt})`, backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat" }}
    >
      <header className="text-center">
        <h1 className="text-3xl md:text-8xl fade-in-once font-bold mb-5 ">MUDDYRIA PRODUCTIONS</h1>
        <h4 className="text-3xl md:text-3xl fade-in-once font-bold mb-12 ">(a.k.a. Madhu Ratnkar)</h4>
        <p className="text-base md:text-2xl mb-8 fade-in-once">Explore my projects!</p>
        <div>
          <button
            onClick={handleShowProjects}
            className="bg-indigo-500 hover:bg-indigo-700 text-white font-bold py-2 px-6 rounded-full shadow-lg transform transition duration-500 hover:scale-105 glow-effect fade-in-once"
          >
            {showProjects ? "Hide Projects" : "Show Projects"}
          </button>
        </div>
      </header>

      {showProjects && (
        <section className="mt-12 w-full">
          <h2 className="text-2xl font-semibold mb-6 text-center">Featured Projects</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 p-4">
            {/* Project Card with Image and Hover Text */}
            <div className="relative bg-gray-800 p-6 rounded-lg shadow-lg flex items-center justify-center group">
              <a href="http://muddyria.com/colorpalette/" target="_blank" rel="noopener noreferrer">
                <img
                  className="h-auto max-w-full"
                  src={colorButton}
                  alt="Color Palette Generator"
                />
                {/* Text that appears on hover */}
                <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 text-white text-lg font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  Color Palette Generator
                </div>
              </a>
            </div>
            {/* Placeholder project cards */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg flex items-center justify-center text-white">
              Coming Soon
            </div>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg flex items-center justify-center text-white">
              Coming Soon
            </div>
          </div>
        </section>
      )}
    </div>
  );
}

export default App;
